export default "__VITE_ASSET__CXteR8ET__"